import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const ORDER_MESSAGES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            message: 'message',
            viewed: 'viewed'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'c',
            message: 'm',
            viewed: 'v'
        })
    })
})()
